import React from 'react';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import LogoIcon from './icons/logoIcon';

export default function Logo(props) {
  const { size = 40 } = props;

  return (
    <Flex
      as={Link}
      to="/home"
      gap="10px"
      alignItems="center"
      textDecoration="none"
      _hover={{ textDecoration: "none", opacity: 0.85 }}
      transition="opacity 0.2s ease"
      aria-label="Résonance — Retour à l'accueil"
    >
      <Icon
        as={LogoIcon}
        boxSize={size + 'px'}
      />
      <Text
        fontSize="20px"
        fontWeight="600"
        fontFamily="Inter, sans-serif"
        color="black"
        lineHeight="1"
      >
        Résonance
      </Text>
    </Flex>
  );
}
